/**
 * Created by pawel on 30/11/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import {DocumentOrderValues} from "../my-documents/document-order-filter";

export interface AttachmentRequestParameters {
  page: number;
  query?: string;
  orderBy?: DocumentOrderValues;
}

export interface AttachmentResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: IFileAttachment[];
}

interface IAttachmentEvent {
  id: number,
  title: string
}

export interface IFileAttachment {
  id: number,
  public_url: string,
  file_name: string,
  size: number,
  mime_type: string,
  created: string,
  event: IAttachmentEvent,
  comment: number,
  public_thumbnail_url: string,
  is_owner: boolean
}


export class FileAttachment {
  public static APPL = "application/";
  public static IMAGE = "image/";
  public static ICON = "icon";

  public image_flag = true;

  constructor(public id: number = 0,
              public url: string = "",
              public filename: string = "",
              public mimetype: string = "",
              public size: number = 0,
              public created: string = "",
              public event: IAttachmentEvent = null,
              public comment: number = 0,
              public thumbnail_url: string = "",
              public active: boolean = false,
              public isOwner: boolean = false) {

    if (mimetype.startsWith(FileAttachment.IMAGE)) {
      this.image_flag = true;
    }
  }

  isImage(): boolean {
    return this.mimetype.startsWith(FileAttachment.IMAGE);
  }

  isDocument(): boolean {
    return !this.isImage();
  }

  getDocumentIcon(): string {
    if (this.isDocument()) {
      return "icon-clip";
    } else {
      return "";
    }
  }

  static toggleDocument(document: FileAttachment, active) {
    return new FileAttachment(document.id, document.url, document.filename, document.mimetype, document.size,
      document.created, document.event, document.comment, document.thumbnail_url, active, document.isOwner)
  }

  static fromPayload(payload: IFileAttachment) {
    return new FileAttachment(payload.id, payload.public_url, payload.file_name, payload.mime_type, payload.size, payload.created,
      payload.event, payload.comment, payload.public_thumbnail_url, false, payload.is_owner)
  }
}
